import React from 'react';
import PropTypes from 'prop-types';
import { formatDate } from '../../utils/date';

const PriceButton = ({
    diffusionCourseName,
    horseName,
    saddleClothNo,
    raceDatetime,
    raceInstanceUid,
}) => (
    <div className="js-PC-runnerRow hp-price-button__wrapper">

        { saddleClothNo &&
            <div className="RC-runnerNumber__no" data-horseName={horseName}>{saddleClothNo}</div>
        }
        <div
            className="js-diffusionHorsesList js-bestOddsPriceContainer js-horsesList"
            data-card-race-date-time={raceDatetime}
            data-diffusion-horsename={horseName}
            data-diffusion-race-id={raceInstanceUid}
            data-diffusion-racedate={formatDate(raceDatetime, 'YYYY-MM-DD')}
            data-diffusion-coursename={diffusionCourseName}
            data-diffusion-racetime={formatDate(raceDatetime, 'HH:mm')}
        >
            <div
                className={
                    `ui-priceBtn_noPrice ui-btn js-diffusionPriceValue
                    js-betHandler js-runnerPrice js-runnerPriceBestOdds`
                }
            />
        </div>
        <div className="js-bestOddsRunnerHorseName hide">
            { horseName }
        </div>
    </div>
);

PriceButton.propTypes = {
    horseName: PropTypes.string.isRequired,
    saddleClothNo: PropTypes.number,
    raceInstanceUid: PropTypes.number.isRequired,
    raceDatetime: PropTypes.string.isRequired,
    diffusionCourseName: PropTypes.string.isRequired,
};

export default PriceButton;



// WEBPACK FOOTER //
// ./src/js/shared/price/PriceButton.jsx